export class OutletConfiguration {
    constructor(hasDmsReadAccess, hasDmsWriteAccess, isDmsSearchForLicensePlateEnabled, isDmsUsDirectEnabled, isGdprEnabled, isServiceHistoryDeletionEnabled, showFlatRateUnitAmount, dmsCostCenterForSipActivated, dmsCostUnitAccountIdForSip, dmsCostUnitDescriptionForSip) {
        this.hasDmsReadAccess = hasDmsReadAccess;
        this.hasDmsWriteAccess = hasDmsWriteAccess;
        this.isDmsSearchForLicensePlateEnabled = isDmsSearchForLicensePlateEnabled;
        this.isDmsUsDirectEnabled = isDmsUsDirectEnabled;
        this.isGdprEnabled = isGdprEnabled;
        this.isServiceHistoryDeletionEnabled = isServiceHistoryDeletionEnabled;
        this.showFlatRateUnitAmount = showFlatRateUnitAmount;
        this.dmsCostCenterForSipActivated = dmsCostCenterForSipActivated;
        this.dmsCostUnitAccountIdForSip = dmsCostUnitAccountIdForSip;
        this.dmsCostUnitDescriptionForSip = dmsCostUnitDescriptionForSip;
    }
    getHasDmsReadAccess() {
        return this.hasDmsReadAccess;
    }
    getHasDmsWriteAccess() {
        return this.hasDmsWriteAccess;
    }
    getIsDmsSearchForLicensePlateEnabled() {
        return this.isDmsSearchForLicensePlateEnabled;
    }
    getIsDmsUsDirectEnabled() {
        return this.isDmsUsDirectEnabled;
    }
    getIsGdprEnabled() {
        return this.isGdprEnabled;
    }
    getIsServiceHistoryDeletionEnabled() {
        return this.isServiceHistoryDeletionEnabled;
    }
    getShowFlatRateUnitAmount() {
        return this.showFlatRateUnitAmount;
    }
    getDmsCostCenterForSipActivated() {
        return this.dmsCostCenterForSipActivated;
    }
    getDmsCostUnitAccountIdForSip() {
        return this.dmsCostUnitAccountIdForSip;
    }
    getDmsCostUnitDescriptionForSip() {
        return this.dmsCostUnitDescriptionForSip;
    }
}
OutletConfiguration.constructFromPlainObject = (source) => {
    return new OutletConfiguration(source.hasDmsReadAccess, source.hasDmsWriteAccess, source.isDmsSearchForLicensePlateEnabled, source.isDmsUsDirectEnabled, source.isGdprEnabled, source.isServiceHistoryDeletionEnabled, source.showFlatRateUnitAmount, source.dmsCostCenterForSipActivated, source.dmsCostUnitAccountIdForSip, source.dmsCostUnitDescriptionForSip);
};
//# sourceMappingURL=outletConfiguration.js.map